import {
  GET_STUDY,
  GET_GEOM,
  GET_ANALYSES,
  ADD_ANALYSIS_GEOM,
  REMOVE_ANALYSIS_GEOM,
  GET_DOWNLOADS,
  SORT_ANALYSES_BY_DATE,
  SORT_ANALYSES_BY_ALPHA,
  SORT_ANALYSES_BY_ECONOMIC_LOSSES_LOW_TO_HIGH,
  SORT_ANALYSES_BY_ECONOMIC_LOSSES_HIGH_TO_LOW,
  CLEAR_DETAILS,
} from "../actions/types";

const initialState = {
  id: "",
  name: "",
  scale: "",
  geom: {},
  analysis_geoms: [],
  image: "",
  analyses: [],
};

const details = (state = initialState, action) => {
  const { type, payload } = action;
  const _state = { ...state };
  switch (type) {
    case GET_STUDY:
      Object.keys(payload).map((key) => (_state[key] = payload[key]));
      return _state;
    case GET_GEOM:
      return { ...state, geom: payload };
    case ADD_ANALYSIS_GEOM:
      return { ...state, analysis_geoms: [...state.analysis_geoms, payload] };
    case REMOVE_ANALYSIS_GEOM:
      return {
        ...state,
        analysis_geoms: [
          ...state.analysis_geoms.filter((geom) => geom.id !== payload.id),
        ],
      };
    case GET_ANALYSES:
      return { ...state, analyses: payload };
    case GET_DOWNLOADS:
      const { analysis_id, downloads } = payload;
      for (let i = 0; i < _state.analyses.length; i++) {
        if (_state.analyses[i].id === parseInt(analysis_id)) {
          _state.analyses[i].downloads = downloads;
        }
      }
      return _state;
    case SORT_ANALYSES_BY_DATE:
      payload === "old-new"
        ? _state.analyses.sort((a, b) => (a.date > b.date ? 1 : -1))
        : _state.analyses.sort((a, b) => (a.date < b.date ? 1 : -1));
      return { ...state, analyses: [..._state.analyses] };
    case SORT_ANALYSES_BY_ALPHA:
      payload === "a-z"
        ? _state.analyses.sort((a, b) => (a.name > b.name ? 1 : -1))
        : _state.analyses.sort((a, b) => (a.name < b.name ? 1 : -1));
      return { ...state, analyses: [..._state.analyses] };
    case SORT_ANALYSES_BY_ECONOMIC_LOSSES_LOW_TO_HIGH:
      _state.analyses.sort((a, b) => (a.totalLosses < b.totalLosses ? 1 : -1));
      return { ...state, analyses: [..._state.analyses] };
    case SORT_ANALYSES_BY_ECONOMIC_LOSSES_HIGH_TO_LOW:
      _state.analyses.sort((a, b) => (a.totalLosses > b.totalLosses ? 1 : -1));
      return { ...state, analyses: [..._state.analyses] };
    case CLEAR_DETAILS:
      return { ...state, ...initialState };
    default:
      return state;
  }
};

export default details;
